/* eslint-disable max-len */
import React from 'react';
import './css/Description.css';
import {
  DESC_TITLE1,
  DESC_TITLE2,
  DESC_TITLE3,
  SEARCH_TOUR,
  DESC_SECTION1_TITLE,
  DESC_SECTION1_PARAGRAPHS,
  DESC_SECTION2_TITLE,
  DESC_SECTION2_PARAGRAPHS,
} from '../../../Utils/Constants/HomePageConstants';
import Ballons from '../../../images/balloons-r.png';

function Description() {
  const renderParagraphs = (paragraphs) =>
    paragraphs.map((text) => (
      <p key={text} className="h_desc_text_p">
        {text}
      </p>
    ));

  return (
    <div>
      <div className="h_description">
        <div className="containerW">
          <div className="h_desc_title_w">
            <div className="h_desc_title_line">
              <img src={Ballons} alt="ballons" className="h_desc_balloon" />
              <div className="h_desc_title">{DESC_TITLE1}</div>
            </div>
            <div className="h_desc_title_line">
              <div className="h_desc_title">{DESC_TITLE2}</div>
              <div className="h_desc_3 h_desc_title h_desc_title_bold">
                {DESC_TITLE3}
              </div>
              <button
                type="button"
                className="wr_text_16 h_desc_search_button"
                onClick={() => {
                  window.scrollTo({
                    top: 0,
                    behavior: 'smooth',
                  });
                }}
              >
                {SEARCH_TOUR}
              </button>
            </div>
          </div>
          <div className="h_desc_text_section">
            <div className="h_desc_text_section_left h_desc_first_sectition">
              {/* <img src={Desc1} alt="" /> */}
            </div>
            <div className="h_desc_text_section_right">
              <h2 className="h_desc_section_title mb_20">
                {DESC_SECTION1_TITLE}
              </h2>
              {renderParagraphs(DESC_SECTION1_PARAGRAPHS)}
            </div>
          </div>

          <div className="h_desc_text_section">
            <div className="h_desc_text_section_left h_desc_second_sectition">
              {/* <img src={Desc2} alt="" /> */}
            </div>
            <div className="h_desc_text_section_right">
              <h2 className="h_desc_section_title mb_20">
                {DESC_SECTION2_TITLE}
              </h2>
              {renderParagraphs(DESC_SECTION2_PARAGRAPHS)}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Description;
